<template>
	<div class="container-fluid" id="profile_section">
		<div>
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="fas fa-users pr-1"></i>
						<span v-text="this.$route.meta.title"></span> (<small v-text="totalRows"></small>)
					</h2>
				</div>
			</div>

			<div class="row" id="members_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search Members"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-5 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-7 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						id="connections_table"
						bordered
						responsive="md"
						:items="members_sharing"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
						empty-text="There are no connections to show..."
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template>
							<b-tr v-if="thead_top.length > 0">
								<b-th
									v-for="(v, k) in thead_top"
									:key="k"
									:colspan="v.colspan"
									:variant="v.variant"
									:class="v.class"
								>
									<span v-text="v.text"></span>
								</b-th>
							</b-tr>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown size="sm" class="" toggle-class="text-decoration-none" no-caret>
								<template #button-content>
									<span v-if="data.item.alerts.total > 0" class="mr-1">
										<i class="fas fa-bell text-danger"></i>
									</span>
									<span v-else>
										<i class="fas fa-angle-down gold"></i>
									</span>
								</template>

								<b-dropdown-item v-if="challengesEnabled === false">
									<router-link :to="'/dashboard/' + data.item.user_id_1" class="gold">
										View <span v-text="data.item.first_name"></span>'s Dashboard
									</router-link>
								</b-dropdown-item>

								<b-dropdown-item v-if="challengesEnabled === true">
									<router-link :to="'/profile_report/' + data.item.id" class="gold">
										View <span v-text="data.item.first_name"></span>'s Report
									</router-link>
								</b-dropdown-item>

								<b-dropdown-item>
									<router-link
										:to="`/chatbox/${challengesEnabled === true ? data.item.id : data.item.user_id_1}`"
										class="gold"
                  >
										Chat now
									</router-link>
								</b-dropdown-item>
							</b-dropdown>
						</template>

						<template v-slot:cell(full_name)="data">
							<span v-text="data.item.full_name"></span>
						</template>

						<template v-slot:cell(user_score)="data">
							<router-link
								v-if="data.item.user_score > 0"
								:to="'/dashboard/' + data.item.user_id_1"
								class="d-flex"
							>
								<b-progress
									:value="data.item.user_score"
									max="100"
									show-value
									:variant="progressColour(data.item.user_score)"
									style="height: 20px; width: 150px"
									class="float-right"
								></b-progress>
							</router-link>
							
							<small
								v-for="(val, index) in data.item.score_data.type"
								:key="'score_' + index"
							>
								- <small v-text="index"></small>: <span v-text="val"></span>
							</small>
						</template>

						<template v-slot:cell(level)="data">
							<span v-text="arrayElmGet(options.levels, data.item.level)"></span>
						</template>

						<template v-slot:cell(last_session)="data">
							<span v-text="data.item.last_session.date" class="mr-1"></span>
							<span v-text="data.item.last_session.time"></span>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Connections',
	components: {},
	props: {},
	data() {
		return {
			errors: {},
			members_sharing: null,
			fields: [],
			thead_top: [],
			isBusy: true,
			sortBy: null,
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			challengesEnabled: false,
			bool: false,
			
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
			muse: {
				file: null,
				processing: 0,
				message: '',
			},
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		ConnectionsGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('user_id', this.$store.state.profile.id);

			if (this.$route.params.challenge_id) {
				params.append('challenge_id', this.$route.params.challenge_id);
				this.challengesEnabled = true;

			}

			
			axios({
				url: _this.$store.state.api_url + 'ConnectionsGet',
				params: params,
			})
				.then(function (response) {
                    _this.isBusy = false;
					if (response.data.status == 1) {
						console.log('sucesss.');
						if (_this.$route.params.challenge_id) {
							console.log("challenge id present");
							_this.members_sharing = response.data.members_sharing;
						}
						else {
							console.log("user id present");
							_this.members_sharing = response.data.members_sharing;
						}					
						_this.thead_top = response.data.fields.thead_top;
						_this.fields = response.data.fields.data;						
						_this.sortBy = response.data.fields.sort.sortBy;
						_this.sortDesc = response.data.fields.sort.sortDesc;
					} 
					else {
						_this.members_sharing = null;
						console.log('fail.');
					}
					
					_this.totalRows = _this.members_sharing.length;
				})
				.catch(function () {
					console.log('Error: SharedMembersGet.');
				});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		
	},
	created() {},
	mounted() {
		this.ConnectionsGet();
	},
	watch: {},
};
</script>

<style scoped>
th.score_width {
	min-width: 180px !important;
}
th.last_session {
	min-width: 160px !important;
}
</style>
